import { AutomaticListsPage } from "apps/propertySelection/automaticLists/Page";
import { criticalMark } from "libs/analytics/criticalMark";

export default criticalMark(AutomaticListsPage, "AutomaticListsPage");
